import { useEffect, useState } from "react";

import {
  Alert,
  alpha,
  AppBar,
  Avatar,
  Box,
  Container,
  CssBaseline,
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  createSvgIcon,
  useTheme,
} from "@mui/material";

import { Outlet, useNavigate, useLocation } from "react-router-dom";

import useStyles from "./styles";

import {
  AttachMoneyOutlined,
  BarChart,
  DarkModeOutlined,
  Dashboard,
  Home,
  HomeOutlined,
  HubOutlined,
  InsertDriveFileOutlined,
  LightModeOutlined,
  LockReset,
  LogoutOutlined,
  MenuOutlined,
  MonitorHeart,
  PermIdentityOutlined,
  PersonOutline,
  Phonelink,
  ReceiptOutlined,
  RequestQuoteOutlined,
  RouterOutlined,
  SecurityOutlined,
  SupervisorAccountOutlined,
  SupportAgentOutlined,
  TipsAndUpdatesOutlined,
  VpnKeyOutlined,
} from "@mui/icons-material";
import ModalEditSenhaClienteLogado from "../../../components/externoModalEditSenha";
import ModalPerfil from "../../../components/modalPerfil";
import SideBar from "../../../components/sideBar";
import LoaderThreeDots from "../../../components/loadingAnimation";

import dayjs from "dayjs";
import apiCliente from "../../../services/apiCliente";
import useRotasDisponiveisCliente from "../hooksPermissao/useRotasDisponiveisCliente";
import usePermissoesRotasCliente from "./usePermissoesRotasCliente";
import { ReactComponent as EasyFlow } from "../../../assets/icons/IconEasyFlow.svg";
const EasyFlowIcon = createSvgIcon(<EasyFlow />);
const OpticalTransceiverIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    {/* Corpo do módulo */}
    <rect
      x="4"
      y="7"
      width="14"
      height="10"
      rx="2"
      ry="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />

    {/* Porta de conexão (frente do transceptor) */}
    <rect
      x="18"
      y="10"
      width="3"
      height="4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />

    {/* Detalhes internos (contatos) */}
    <line x1="6" y1="9" x2="14" y2="9" stroke="currentColor" strokeWidth="1" />
    <line
      x1="6"
      y1="15"
      x2="14"
      y2="15"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>,
  "OpticalTransceiver",
);

export default function LayoutClient(params) {
  const perfil = JSON.parse(localStorage.getItem("perfilCliente"));
  // ERP, financeiro oculto e demais regras de disponibilidade agora ficam em
  // useRotasDisponiveisCliente
  const theme = useTheme();
  const styles = useStyles(theme);
  const { colorMode, setColorMode } = params;

  // Permissões do usuário logado. Ficam aqui (e não no App.js) porque o login é
  // uma navegação dentro da SPA: um estado criado no mount do App continuaria
  // com os dados da sessão anterior até um F5.
  const {
    admPermissao,
    routesPermissao,
    carregado: permissoesCarregadas,
  } = usePermissoesRotasCliente();

  // Telas que existem de fato para este cliente (infra, ERP, relatórios, sugestões).
  // Mesma fonte usada pela tela de permissões do portal.
  const { loading, rotasDisponiveis } = useRotasDisponiveisCliente();

  // Rota liberada pela permissão do usuário (ADM enxerga tudo)
  const podeVer = (path) => admPermissao || !!routesPermissao[path];

  // Uma tela só entra no menu se existir para este cliente E estiver liberada
  // pela permissão do usuário
  const podeExibir = (path) => !!rotasDisponiveis[path] && podeVer(path);

  const [anchorEl, setAnchorEl] = useState(null);
  const [baseImage, setBaseImage] = useState(
    JSON.parse(localStorage.getItem("perfilCliente"))?.foto || "",
  );
  const [windowWith, setWindowWith] = useState(window.innerWidth);
  const [openModalPerfil, setOpenModalPerfil] = useState(false);
  const [openModalEditSenha, setOpenModalEditSenha] = useState(false);
  const [snackbar, setSnackbar] = useState(null);

  const [value, setValue] = useState(0);
  const [administrador, setAdministrador] = useState(false);
  const [financeiro, setFinanceiro] = useState(false);
  const [percentil, setPercentil] = useState(false);

  const location = useLocation();
  const path = location.pathname;
  const isMirror = path.includes("mirror");

  // drawer ##########################

  const [titlePage, setTitlePage] = useState("");
  const [openSideBar, setOpenSideBar] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);

  const isScreenSmall = useMediaQuery(theme.breakpoints.up("lg"));

  //################################################################

  //CONTROLLER PARA ABORT ######################################3
  const [controllerDashboard, setControllerDashboard] = useState(null);

  //CONTADOR DE CRONOMETRO E VERIFICADOR DE FILTRO
  const [isFilter, setIsFilter] = useState(false);

  //#################################################33
  // Estados para datas de início e fim

  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigate = useNavigate();

  //FUNÇÃO DE CRONOMETRO

  //#################################################

  const logoDark = `${
    window?.config?.REACT_APP_LOGO_EXTERNO_DARK ||
    process.env.REACT_APP_LOGO_EXTERNO_DARK ||
    ""
  }`;

  useEffect(() => {
    let sidebarOpen = JSON.parse(localStorage.getItem("sidebarCollapsed"));
    if (sidebarOpen !== null) setOpenSideBar(sidebarOpen);
  }, []);
  useEffect(() => {
    if (isScreenSmall) {
      setOpenDrawer(false); // Fecha a sidebar quando a tela é menor que o valor definido no breakpoint 'lg'
    }
  }, [isScreenSmall]);

  useEffect(() => {
    if (loading || !permissoesCarregadas) return;

    const isHomeRoute = path.startsWith("/home");
    if (!isHomeRoute) return;

    // /home é só layout: sempre redireciona para a primeira aba exibível.
    // Nas demais, redireciona só quando a tela não existe para o cliente ou
    // não está liberada pela permissão (senão o usuário cairia no acesso negado).
    const precisaRedirecionar = path === "/home" || !podeExibir(path);
    if (!precisaRedirecionar) return;

    // Mesma ordem de prioridade do menu lateral
    const destino = [
      "/home/overview",
      "/home/firewall",
      "/home/dash/sfp",
      "/home/onu",
      "/home/rede",
      "/home/flow",
    ].find((destinoPath) => podeExibir(destinoPath));

    if (destino) navigate(destino);
    else if (podeExibir("/tickets")) navigate("/tickets");
    else navigate("/resumo");
  }, [
    loading,
    permissoesCarregadas,
    rotasDisponiveis,
    path,
    navigate,
    routesPermissao,
    admPermissao,
  ]);

  const handleDrawerToggle = () => {
    setOpenDrawer((preValue) => !preValue);
  };

  //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  useEffect(() => {
    const pagesDash = [
      "/home/overview",
      "/home/saude",
      "/home/disponibilidade",
      "/home/firewall",
    ];

    setIsFilter(
      pagesDash?.find((page) => window.location.pathname.includes(page))
        ? true
        : false,
    );
  }, [window.location.pathname]);
  useEffect(() => {
    setBaseImage(
      localStorage.getItem("perfilCliente") &&
        JSON.parse(localStorage.getItem("perfilCliente")) != "undefined"
        ? JSON.parse(localStorage.getItem("perfilCliente"))?.foto
        : "",
    );
  }, [localStorage.getItem("perfilCliente")]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    let result = localStorage.getItem("userCliente");
    result = JSON.parse(result);

    const handleUsuarioId = async () => {
      let result = JSON.parse(localStorage.getItem("userCliente"));

      // Relatórios e sugestões são resolvidos por useRotasDisponiveisCliente

      if (
        Array.isArray(result?.usuarioCliente?.cliente?.percentil) ||
        result?.usuarioCliente?.cliente?.percentil?.permissao === true
      ) {
        if (
          result?.usuarioCliente?.cliente?.percentil?.[0]?.permissao === true ||
          result?.usuarioCliente?.cliente?.percentil?.permissao === true
        ) {
          setPercentil(true);
        } else {
          setPercentil(false);
        }
      }

      // Verifica se a propriedade rlPermissoesUsuario existe e é um array
      if (Array.isArray(result?.usuarioCliente?.RlPermissoesUsuarioCliente)) {
        // Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
        for (let permissao of result?.usuarioCliente
          ?.RlPermissoesUsuarioCliente) {
          if (permissao?.permissao?.codigoPermissao?.toUpperCase() === "ADM") {
            setAdministrador(true);
          }
          if (
            permissao?.permissao?.codigoPermissao?.toUpperCase() ===
            "FINANCEIRO"
          ) {
            setFinanceiro(true);
          }
        }
        return false;
      }
    };

    handleUsuarioId();

    const pages = [
      "/home",
      "/financeiro",
      "/relatorios",
      "/blocos",
      "/relatorio",
      "/administracao",
    ];

    const pageName = window.location.pathname;

    for (let index = 0; index < pages.length; index++) {
      if (pageName.includes(pages[index])) {
        setValue(index);
        break;
      }
    }
  }, []);

  //funcoes de controle do menu
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleCloseModalPerfil = () => {
    setOpenModalPerfil(false);
  };

  const dashboardNodes = [
    podeExibir("/home/overview") && {
      itemId: "1.1",
      label: "Overview",
      hideTitle: true,
      link: "/home/overview",
      icon: <Dashboard />,
    },
    podeExibir("/home/saude") && {
      itemId: "1.2",
      label: "Saúde",
      hideTitle: true,
      link: "/home/saude",
      icon: <MonitorHeart />,
    },
    podeExibir("/home/disponibilidade") && {
      itemId: "1.3",
      label: "Disponibilidade",
      hideTitle: true,
      link: "/home/disponibilidade",
      icon: <Phonelink />,
    },
    podeExibir("/home/firewall") && {
      itemId: "1.35",
      label: "Firewall",
      hideTitle: true,
      link: "/home/firewall",
      icon: <SecurityOutlined />,
    },
    podeExibir("/home/dash/sfp") && {
      itemId: "1.4",
      label: "Transceptor óptico",
      hideTitle: true,
      link: "/home/dash/sfp",
      icon: <OpticalTransceiverIcon />,
    },
    podeExibir("/home/onu") && {
      itemId: "1.5",
      label: "ONUs",
      hideTitle: true,
      link: "/home/onu",
      icon: <RouterOutlined />,
    },
    podeExibir("/home/rede") && {
      itemId: "1.6",
      label: "Links e Sessões",
      hideTitle: true,
      link: "/home/rede",
      icon: <HubOutlined />,
    },
    podeExibir("/home/flow") && {
      itemId: "1.7",
      label: "Flow",
      hideTitle: true,
      link: "/home/flow",
      icon: <EasyFlowIcon />,
    },
  ]?.filter(Boolean);

  const financeiroNodes = [
    podeExibir("/financeiro/faturas") && {
      itemId: "6.1",
      label: "Faturas",
      hideTitle: true,
      link: "/financeiro/faturas",
      icon: <RequestQuoteOutlined />,
    },
    podeExibir("/financeiro/nfs") && {
      itemId: "6.2",
      label: "NFs",
      hideTitle: true,
      link: "/financeiro/nfs",
      icon: <ReceiptOutlined />,
    },
    podeExibir("/financeiro/contratos") && {
      itemId: "6.3",
      label: "Contratos",
      hideTitle: true,
      link: "/financeiro/contratos",
      icon: <ReceiptOutlined />,
    },
  ]?.filter(Boolean);

  const sideBarPages = [
    podeExibir("/resumo") && {
      itemId: "0",
      label: "Home",
      hideTitle: true,
      link: "/resumo",
      icon: <HomeOutlined />,
    },
    ...(dashboardNodes.length > 0 && podeVer("/home")
      ? [
          {
            itemId: "1",
            label: "Dashboard",
            hideTitle: true,
            link: dashboardNodes[0].link,
            icon: <BarChart />,
            nodes: dashboardNodes,
          },
        ]
      : []),
    podeExibir("/tickets") && {
      itemId: "5",
      label: "Tickets",
      hideTitle: true,
      link: "/tickets",
      icon: <SupportAgentOutlined />,
    },
    ...(podeVer("/financeiro") && financeiroNodes.length > 0
      ? [
          {
            itemId: "6",
            label: "Financeiro",
            hideTitle: true,
            link: "/financeiro",
            icon: <AttachMoneyOutlined />,
            nodes: financeiroNodes,
          },
        ]
      : []),
    ...(podeExibir("/relatorios")
      ? [
          {
            itemId: "8",
            label: "Relatórios",
            hideTitle: true,
            link: "/relatorios",
            icon: <InsertDriveFileOutlined />,
          },
        ]
      : []),
    ...(podeExibir("/sugestoes")
      ? [
          {
            itemId: "9",
            label: "Sugestões",
            hideTitle: true,
            link: "/sugestoes",
            icon: <TipsAndUpdatesOutlined />,
          },
        ]
      : []),
    ...(administrador
      ? [
          {
            itemId: "7",
            label: "Administração",
            hideTitle: true,
            link: "/administracao",
            icon: <SupervisorAccountOutlined />,
            nodes: [
              {
                itemId: "7.1",
                label: "Usuários",
                hideTitle: true,
                link: "/administracao/usuarios",
                icon: <PermIdentityOutlined />,
              },
              {
                itemId: "7.2",
                label: "Permissões",
                hideTitle: true,
                link: "/administracao/permissoes",
                icon: <VpnKeyOutlined />,
              },
            ],
          },
        ]
      : []),
  ]?.filter(Boolean);

  return (
    <Box display={"flex"}>
      <CssBaseline />
      {windowWith < 1350 && (
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            background: theme.palette.gradient.sidebar,
            ...(isMirror && {
              top: 40,
              "@media (max-width: 681px)": {
                top: 65,
              },
            }),
          }}
        >
          <Container maxWidth="100vw">
            <Toolbar sx={styles.toolbar}>
              <Box sx={styles.toolbarNavigate}>
                <IconButton
                  sx={{
                    padding: "0px",
                    transform: "translateX(-20px)",
                    color: theme.palette.white.main,
                  }}
                  onClick={() => {
                    setDrawerOpen(!drawerOpen);
                    handleDrawerToggle();
                  }}
                >
                  <MenuOutlined fontSize="medium" />
                </IconButton>

                <IconButton href={"/home/overview"} sx={styles.IconButtonLogo}>
                  <Icon style={styles.logo}>
                    <img src={logoDark} style={styles.logo} alt="logo-home" />
                  </Icon>
                </IconButton>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      )}
      <Box sx={{ width: "100%" }}>
        {windowWith < 1350 && <Box sx={{ height: "60px", width: "50vw" }} />}
        <Stack direction={"row"}>
          <SideBar
            defaultExpandedItems={["1", "3", "6", "7"]}
            items={
              administrador || financeiro
                ? sideBarPages
                : sideBarPages.filter(
                    (page) => !["2", "3"].includes(page.itemId),
                  )
            }
            title=""
            titlePage={titlePage}
            setTitlePage={setTitlePage}
            openSideBar={openSideBar}
            setOpenSideBar={setOpenSideBar}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            Perfil={
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 3,
                  alignItems: "center",
                }}
              >
                <Tooltip title="Abrir Opções">
                  {openSideBar ? (
                    <Paper
                      variant={"outlined"}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        background: "transparent",
                        maxWidth: "260px",
                        width: "100%",
                        p: 1,
                        gap: 1,
                        cursor: "pointer",
                        ml: "4px",
                        borderRadius: "20px",
                        border: "1px solid #ffffff54",
                        "&:hover": {
                          background: `linear-gradient(90deg, ${alpha(
                            theme.palette.buttonHoverGradient.dark,
                            0.5,
                          )} 0%, ${alpha(
                            theme.palette.buttonHoverGradient.light,
                            0.5,
                          )} 100%)`,
                        },
                      }}
                      id="basic-button"
                      onClick={handleClick}
                    >
                      <Avatar
                        src={baseImage}
                        sx={{
                          color: theme.palette.white.main,
                          bgcolor: theme.palette.secondary.dark,
                        }}
                      />
                      <Typography
                        noWrap
                        sx={{
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          ml: 1,
                          fontSize: "1rem",
                          fontWeight: 500,
                          color: theme.palette.white.main,
                        }}
                      >
                        {perfil?.nome
                          ? `${perfil?.nome} ${perfil?.sobrenome}`
                          : ""}
                      </Typography>
                    </Paper>
                  ) : (
                    <IconButton onClick={handleClick}>
                      <Avatar
                        src={baseImage}
                        sx={{
                          color: theme.palette.white.main,
                          bgcolor: theme.palette.secondary.dark,
                        }}
                      />
                    </IconButton>
                  )}
                </Tooltip>
              </Box>
            }
          />
          <Box sx={styles.containerFilter}>
            <Box component="main" sx={styles.main}>
              <Box>
                {location.pathname.includes("/home/overview") && loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80vh",
                      width: "100%",
                    }}
                  >
                    <LoaderThreeDots />
                  </Box>
                ) : (
                  <Outlet
                    context={{
                      controllerDashboard,
                      setControllerDashboard,
                      apiCliente,
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
            width: "200px",
            bgcolor: theme.palette.secondary.darker,
            color: theme.palette.white.main,
          },
        }}
      >
        <MenuItem
          onClick={() => setOpenModalPerfil(true)} //</Menu>onClick={handlePerfil}]
        >
          <ListItemIcon>
            <PersonOutline sx={{ color: theme.palette.white.main }} />
          </ListItemIcon>
          <ListItemText>Perfil</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenModalEditSenha(true);
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <LockReset sx={{ color: theme.palette.white.main }} />
          </ListItemIcon>
          <ListItemText>Alterar Senha</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() =>
            setColorMode((prev) => {
              localStorage.setItem("darkMode", !prev);
              return !prev;
            })
          }
        >
          {colorMode ? (
            <>
              <ListItemIcon>
                <DarkModeOutlined sx={{ color: theme.palette.white.main }} />
              </ListItemIcon>
              <ListItemText>Modo Noturno</ListItemText>
            </>
          ) : (
            <>
              <ListItemIcon>
                <LightModeOutlined sx={{ color: theme.palette.white.main }} />
              </ListItemIcon>
              <ListItemText>Modo Claro</ListItemText>
            </>
          )}
        </MenuItem>

        {/* {administrador && (
					<MenuItem
						onClick={() => {
							navigate("/administracao");
						}}
					>
						<ListItemIcon>
							<SupervisorAccountOutlined
								sx={{ color: theme.palette.white.main }}
							/>
						</ListItemIcon>
						<ListItemText>Administração</ListItemText>
					</MenuItem>
				)} */}

        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutOutlined sx={{ color: theme.palette.white.main }} />
          </ListItemIcon>
          <ListItemText>Sair</ListItemText>
        </MenuItem>
      </Menu>
      <ModalPerfil
        open={openModalPerfil}
        handleClose={handleCloseModalPerfil}
      />
      <ModalEditSenhaClienteLogado
        open={openModalEditSenha}
        handleClose={() => {
          setOpenModalEditSenha(false);
        }}
        setSnackbar={setSnackbar}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
